import { ENGINE_PATH_PREFIX } from '@gnsx/genesys.js';

const EXCLUDED_ASSET_PATHS = [
  `${ENGINE_PATH_PREFIX}/assets/dev`
] as const;

const normaliseAssetPath = (path: string): string => path.replaceAll('\\', '/');

const isPathWithinExcludedSubtree = (path: string, excludedPath: string): boolean => {
  const normalisedPath = normaliseAssetPath(path);
  return normalisedPath === excludedPath || normalisedPath.startsWith(`${excludedPath}/`);
};

export const isExcludedAssetPath = (path: string): boolean => {
  return EXCLUDED_ASSET_PATHS.some(excludedPath => isPathWithinExcludedSubtree(path, excludedPath));
};
